module.exports = __webpack_public_path__ + "static/media/search.24a55dcf.svg";